import { cn } from "@omni/utils/styles";

import { useImageContext } from "../../context/image.context";

type Props = {
    className?: string;
};

export const Img = ({ className }: Props) => {
    const {
        image,
        alt,
        lazy,
        mobileImage: _mobileImage,
        ...props
    } = useImageContext();

    return (
        <img
            {...props}
            className={cn("tw:w-full tw:h-full", className)}
            src={image.src}
            srcSet={image.srcSet}
            alt={alt}
            width={image.width}
            height={image.height}
            loading={lazy ? "lazy" : "eager"}
            decoding={lazy ? "async" : "auto"}
            fetchPriority={lazy ? "auto" : "high"}
        />
    );
};
